<template>
  <div id="sentimiento" class="sentimiento">
    <div class="corazon">
      <a @click="sendLike(); trackCorazon();">
        <img src="../assets/img/corazon.png" class="img-fluid">
      </a>
    </div>
    <div id="corazones"></div>
  </div>
</template>

<script>
import firebase from "firebase";
import fire from "@/fire";

export default {
  name: "Sentimiento",
  data() {
    return {
      sentimientos: [],
      numerolike: 0,
      hearts: [],
      speed: 0.8,
      brd: null,
      before: Date.now(),
      id0: null,
      duration: 3000,
      cursorXOffset: 0,
      cursorYOffset: -5,
      likes: 0,
      initialX: 300,
      initialY: 300
    };
  },
  methods: {
    sendLike() {
      fire
        .database()
        .ref("sentimientos")
        .update(
          {
            likes: this.likes + 1
          },
          (error) => {
            if (error) {
              // console.log("The write failed");
            } else {
              // console.log("Data saved successfully!");
              this.insertarCorazon()
            }
          }
        );
    },
    trackCorazon() {
      fire.analytics().logEvent('chat_like', { item_id: 'button_click', item_name: 'chat_like' })
    },
    generateHeart(x, y, xBound, xStart, scale) {
      // console.log("BRD ",this.brd);
      let heart = document.createElement("DIV");
      heart.setAttribute('class', 'heart');
      this.brd.appendChild(heart);
      heart.time = this.duration;
      heart.x = x;
      heart.y = y;
      heart.bound = xBound;
      heart.direction = xStart;
      heart.style.left = heart.x + "px";
      heart.style.top = heart.y + "px";
      heart.scale = scale;
      heart.style.transform = "scale(" + scale + "," + scale + ")";
      if (this.hearts == null)
        this.hearts = [];
      this.hearts.push(heart);
      return heart;
    },
    frame() {
      let current = Date.now();
      let deltaTime = current - this.before;
      this.before = current;
      for (let i in this.hearts) {
        // console.log("valor i for: ",i);
        let heart = this.hearts[i];
        heart.time -= deltaTime;
        if (heart.time > 0) {
          heart.y -= this.speed;
          heart.style.top = heart.y + "px";
          heart.style.left = heart.x + heart.direction * heart.bound * Math.sin(heart.y * heart.scale / 30) + "px";
        } else {
          heart.parentNode.removeChild(heart);
          this.hearts.splice(parseInt(i), 1);
        }
      }
    },
    insertarCorazon() {
      let start = 1 - Math.round(Math.random()) * 2;
      let scale = Math.random() * Math.random() * 0.3 + 0.2;
      let bound = 5;
      this.generateHeart(this.initialX, this.initialY, bound, start, scale);
    },
    ocultar() {
      let corazon = document.getElementById("corazones");
      let classes = corazon.classList;
      classes.remove("heart");
      corazon.textContent = classes;
    },
    //
  },
  mounted() {
    let element = document.getElementById("sentimiento");
    var rect = element.getBoundingClientRect();
    this.initialY = window.innerHeight - 150;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.initialY = window.innerHeight - 300;
    }
    else {
      this.initialY = window.innerHeight - 150;
    }

    this.initialX = Math.round(rect.right) - 30;

    const heartContainer = document.querySelector('.heart-container');

    if (!heartContainer) {
      this.brd = document.createElement("DIV");
      this.brd.setAttribute('class', 'heart-container');
      document.body.appendChild(this.brd);
    } else {
      this.brd = heartContainer;
    }

    setInterval(this.frame, 5);
    let ref = this;
    const itemsRef = fire.database().ref("sentimientos");
    itemsRef.on("value", snapshot => {
      let data = snapshot.val();
      if (data.likes > ref.likes) {
        ref.insertarCorazon();
        ref.likes = data.likes;
      }

    });
  },

}
</script>

<style lang="scss">
.sentimiento {
  position: absolute;
  width: 40px;
  height: 40px;
  right: 16px;
  bottom: 55px;
  cursor: pointer;
  z-index: 20;

  @media (max-width: 701px) {
    .sentimiento {
      bottom: 45px;
      right: 5px;
    }
  }

  @media (max-width: 480px) {
    bottom: 20px;
    right: 5px;
  }


  @media (max-width: 285px) {
    .sentimiento {
      bottom: 15px;
      right: 5px;
    }

  }
}

@keyframes heartfade {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.heart {
  z-index: 999;
  animation: heartfade 6s linear;
  position: absolute;
}

.heart:before,
.heart:after {
  content: "";
  background-color: red;
  position: absolute;
  height: 30px;
  width: 45px;
  border-radius: 15px 0px 0px 15px;
}

.heart:before {
  transform: rotate(45deg);
}

.heart:after {
  left: 10.5px;
  transform: rotate(135deg);
}

.corazon {
  width: 40px;
  height: 40px;
  transition: all 0.5s ease;
  /*
  animation:beat 1s infinite alternate ease-in-out;
  */
}

.corazon:hover {
  transform: scale(1.05);
}

@keyframes beat {
  to {
    transform: rotate(45deg) scale(1.05);
  }
}
</style>
